import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import EditCompetitionModal from './EditCompetitionModal';
export default class CompetitionsPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "competitions", []);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "filter", '');
    _defineProperty(this, "formatFilter", 'all');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    this.loadCompetitions();
  }
  loadCompetitions() {
    this.loading = true;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/competitions'
    }).then(response => {
      this.competitions = response && response.data ? response.data.map(item => app.store.pushObject(item)) : [];
    }).catch(err => {
      console.error('Error loading competitions:', err);
      app.alerts.show({
        type: 'error'
      }, 'Error al cargar las competiciones.');
      this.competitions = [];
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  openCreateModal() {
    app.modal.show(EditCompetitionModal, {
      onSaved: () => this.loadCompetitions()
    });
  }
  openEditModal(comp) {
    app.modal.show(EditCompetitionModal, {
      competition: comp,
      onSaved: () => this.loadCompetitions()
    });
  }
  deleteCompetition(comp) {
    const matchesCount = comp.matchesCount ? comp.matchesCount() : 0;
    if (matchesCount > 0) {
      app.alerts.show({
        type: 'error'
      }, "No se puede eliminar la competici\xF3n \"".concat(comp.nameEs() || comp.name(), "\": tiene ").concat(matchesCount, " partidos asociados."));
      return;
    }
    if (!confirm("\xBFEst\xE1s seguro de que deseas eliminar la competici\xF3n \"".concat(comp.nameEs() || comp.name(), "\"?"))) {
      return;
    }
    app.request({
      method: 'DELETE',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/competitions/".concat(comp.id())
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, 'Competición eliminada con éxito.');
      this.competitions = this.competitions.filter(c => c.id() !== comp.id());
      m.redraw();
    }).catch(err => {
      console.error('Error deleting competition:', err);
      const msg = err && err.response && err.response.errors && err.response.errors[0] && err.response.errors[0].detail || 'Error al eliminar la competición.';
      app.alerts.show({
        type: 'error'
      }, msg);
    });
  }
  getFormatLabel(format) {
    switch (format) {
      case 'league':
        return 'Liga regular';
      case 'cup':
        return 'Copa (eliminatoria)';
      case 'tournament':
        return 'Torneo mixto';
      case 'friendly':
        return 'Amistoso';
      default:
        return format;
    }
  }
  view() {
    if (!this.canManage) return null;
    const filtered = this.competitions.filter(c => {
      const name = (c.nameEs() || c.name() || '').toLowerCase();
      const shortName = (c.shortName() || '').toLowerCase();
      const slug = (c.slug() || '').toLowerCase();
      const q = this.filter.toLowerCase().trim();
      const matchesText = !q || name.includes(q) || shortName.includes(q) || slug.includes(q);
      const matchesFormat = this.formatFilter === 'all' || c.format() === this.formatFilter;
      return matchesText && matchesFormat;
    });
    return m("div", {
      className: "CompetitionsPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 60px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 35px; flex-wrap: wrap;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), "Volver a Taldezaina"), m(Link, {
      href: "/",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-home"
    }), "Inicio")), m("div", {
      style: "display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 30px; flex-wrap: wrap; gap: 20px;"
    }, m("div", null, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em; display: flex; align-items: center; gap: 12px;"
    }, "\uD83C\uDFC6 Gesti\xF3n de Competiciones"), m("p", {
      style: "color: var(--muted-color); font-size: 1.1em; margin-top: 8px; max-width: 650px; line-height: 1.5;"
    }, "Configura los torneos disputados por el club y sus reglas: 11 Aldeanos, La Bolilla, c\xF3mputo para Txapela anual, notas a jugadores e icono oficial.")), m(Button, {
      className: "Button Button--primary",
      onclick: this.openCreateModal.bind(this),
      style: "border-radius: 8px; display: inline-flex; align-items: center; gap: 8px; font-weight: bold; padding: 12px 22px; font-size: 1em;"
    }, m("i", {
      className: "fas fa-plus"
    }), " Nueva Competici\xF3n")), m("div", {
      style: "display: flex; gap: 15px; margin-bottom: 30px; flex-wrap: wrap; align-items: center;"
    }, m("div", {
      style: "flex: 1; min-width: 250px; display: flex; align-items: center; gap: 10px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 8px 14px;"
    }, m("i", {
      className: "fas fa-search",
      style: "color: var(--muted-color);"
    }), m("input", {
      className: "FormControl",
      placeholder: "Buscar por nombre, slug o sigla...",
      value: this.filter,
      oninput: e => this.filter = e.target.value,
      style: "border: none; background: transparent; padding: 0; color: inherit; width: 100%; box-shadow: none;"
    })), m("div", {
      style: "display: flex; gap: 8px; flex-wrap: wrap;"
    }, [{
      key: 'all',
      label: 'Todas'
    }, {
      key: 'league',
      label: 'Liga'
    }, {
      key: 'cup',
      label: 'Copa'
    }, {
      key: 'tournament',
      label: 'Torneos'
    }, {
      key: 'friendly',
      label: 'Amistosos'
    }].map(tab => m("button", {
      type: "button",
      className: "Button ".concat(this.formatFilter === tab.key ? 'Button--primary' : 'Button--secondary'),
      onclick: () => {
        this.formatFilter = tab.key;
        m.redraw();
      },
      style: "border-radius: 6px; padding: 6px 14px; font-size: 0.9em; font-weight: 600;"
    }, tab.label)))), this.loading ? m("div", {
      style: "padding: 60px; text-align: center;"
    }, m(LoadingIndicator, null)) : filtered.length === 0 ? m("div", {
      style: "padding: 50px; text-align: center; background: rgba(255,255,255,0.02); border-radius: 12px; border: 1px solid rgba(255,255,255,0.06); color: var(--muted-color);"
    }, m("i", {
      className: "fas fa-trophy",
      style: "font-size: 3em; margin-bottom: 12px; display: block; opacity: 0.3;"
    }), m("p", {
      style: "font-size: 1.1em; margin: 0;"
    }, "No se encontraron competiciones con los filtros aplicados.")) : m("div", {
      style: "display: grid; grid-template-columns: repeat(auto-fill, minmax(360px, 1fr)); gap: 20px;"
    }, filtered.map(comp => {
      const matchesCount = comp.matchesCount ? comp.matchesCount() : 0;
      const compColor = comp.color() || '#ee2524';
      const allowsLineup = comp.allowsLineup() !== false;
      const countsLineup = comp.countsForLineupStanding() !== false;
      const allowsBolilla = comp.allowsBolilla() !== false;
      const countsBolilla = comp.countsForBolillaStanding() !== false;
      const allowsRatings = comp.allowsRatings() !== false;
      const isOfficial = comp.isOfficial() !== false;
      return m("div", {
        key: comp.id(),
        className: "CompetitionCard",
        style: "background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 14px; padding: 22px; display: flex; flex-direction: column; justify-content: space-between; transition: transform 0.2s ease, border-color 0.2s ease; box-shadow: 0 4px 15px rgba(0,0,0,0.1);"
      }, m("div", null, m("div", {
        style: "display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; margin-bottom: 16px;"
      }, m("div", {
        style: "display: flex; align-items: center; gap: 14px;"
      }, m("div", {
        style: "width: 46px; height: 46px; border-radius: 12px; background: ".concat(compColor, "1a; border: 1px solid ").concat(compColor, "44; display: flex; align-items: center; justify-content: center; flex-shrink: 0;")
      }, comp.iconUrl && comp.iconUrl() ? m("img", {
        src: comp.iconUrl(),
        alt: "",
        style: "width: 28px; height: 28px; object-fit: contain;"
      }) : m("span", {
        style: "font-size: 1.4em; color: ".concat(compColor, ";")
      }, "\uD83C\uDFC6")), m("div", null, m("h3", {
        style: "margin: 0; font-size: 1.25em; font-weight: 800; color: var(--heading-color); line-height: 1.2;"
      }, comp.nameEs() || comp.name()), m("div", {
        style: "display: flex; gap: 6px; align-items: center; margin-top: 4px; flex-wrap: wrap;"
      }, comp.shortName() && m("span", {
        className: "CompBadge",
        style: "background: ".concat(compColor, "; color: #fff; font-size: 0.75em; padding: 1px 6px; border-radius: 4px; font-weight: bold;")
      }, comp.shortName()), m("span", {
        style: "font-size: 0.8em; color: var(--muted-color); font-family: monospace;"
      }, "#", comp.slug())))), m("div", {
        style: "display: flex; gap: 6px;"
      }, m("button", {
        type: "button",
        className: "Button Button--icon",
        title: "Editar competici\xF3n",
        onclick: () => this.openEditModal(comp),
        style: "border-radius: 8px; background: rgba(255,255,255,0.06); padding: 8px;"
      }, m("i", {
        className: "fas fa-pencil-alt"
      })), m("button", {
        type: "button",
        className: "Button Button--icon",
        title: matchesCount > 0 ? "Tiene ".concat(matchesCount, " partidos asociados (no se puede borrar)") : 'Eliminar competición',
        disabled: matchesCount > 0,
        onclick: () => this.deleteCompetition(comp),
        style: "border-radius: 8px; background: rgba(255,255,255,0.06); padding: 8px; color: ".concat(matchesCount > 0 ? 'var(--muted-color)' : '#e53935', "; opacity: ").concat(matchesCount > 0 ? 0.4 : 1, "; cursor: ").concat(matchesCount > 0 ? 'not-allowed' : 'pointer', ";")
      }, m("i", {
        className: "fas fa-trash-alt"
      })))), m("div", {
        style: "display: flex; gap: 8px; margin-bottom: 16px; flex-wrap: wrap;"
      }, m("span", {
        className: "CompBadge",
        style: "background: rgba(255,255,255,0.06); color: var(--muted-color); border-radius: 6px; padding: 3px 8px; font-size: 0.8em;"
      }, m("i", {
        className: "fas fa-sitemap",
        style: "margin-right: 4px;"
      }), this.getFormatLabel(comp.format())), m(Link, {
        href: app.route('bizkaitarra-lineup.matches') + "?competition=".concat(comp.id()),
        className: "CompBadge",
        style: "background: rgba(255,255,255,0.06); color: var(--muted-color); border-radius: 6px; padding: 3px 8px; font-size: 0.8em; text-decoration: none; cursor: pointer; transition: background 0.2s ease;",
        title: "Ver partidos de esta competici\xF3n"
      }, m("i", {
        className: "fas fa-futbol",
        style: "margin-right: 4px;"
      }), matchesCount, " ", matchesCount === 1 ? 'partido' : 'partidos'), m("span", {
        className: "CompBadge",
        style: "background: ".concat(isOfficial ? 'rgba(76, 175, 80, 0.15)' : 'rgba(255, 152, 0, 0.15)', "; color: ").concat(isOfficial ? '#4caf50' : '#ff9800', "; border-radius: 6px; padding: 3px 8px; font-size: 0.8em; font-weight: bold;")
      }, isOfficial ? '🛡️ Oficial' : '⚽ Amistoso / No oficial')), m("div", {
        style: "background: rgba(0,0,0,0.18); border-radius: 10px; padding: 12px 14px; display: flex; flex-direction: column; gap: 8px; font-size: 0.85em; border: 1px solid rgba(255,255,255,0.04);"
      }, m("div", {
        style: "display: flex; justify-content: space-between; align-items: center;"
      }, m("span", {
        style: "color: var(--heading-color); font-weight: 600;"
      }, "\u26BD 11 Aldeanos"), m("div", {
        style: "display: flex; gap: 6px;"
      }, m("span", {
        style: "color: ".concat(allowsLineup ? '#4caf50' : '#e53935', "; font-weight: bold;")
      }, allowsLineup ? '✓ Habilitado' : '✗ Bloqueado'), allowsLineup && m("span", {
        className: "CompBadge",
        style: "background: ".concat(countsLineup ? 'rgba(76, 175, 80, 0.2)' : 'rgba(255, 193, 7, 0.2)', "; color: ").concat(countsLineup ? '#4caf50' : '#ffc107', "; font-size: 0.8em; padding: 1px 5px; border-radius: 4px;")
      }, countsLineup ? 'Txapela: Suma' : 'Txapela: No suma'))), m("div", {
        style: "display: flex; justify-content: space-between; align-items: center;"
      }, m("span", {
        style: "color: var(--heading-color); font-weight: 600;"
      }, "\uD83D\uDD2E La Bolilla"), m("div", {
        style: "display: flex; gap: 6px;"
      }, m("span", {
        style: "color: ".concat(allowsBolilla ? '#4caf50' : '#e53935', "; font-weight: bold;")
      }, allowsBolilla ? '✓ Habilitado' : '✗ Bloqueado'), allowsBolilla && m("span", {
        className: "CompBadge",
        style: "background: ".concat(countsBolilla ? 'rgba(76, 175, 80, 0.2)' : 'rgba(255, 193, 7, 0.2)', "; color: ").concat(countsBolilla ? '#4caf50' : '#ffc107', "; font-size: 0.8em; padding: 1px 5px; border-radius: 4px;")
      }, countsBolilla ? 'Anual: Suma' : 'Anual: No suma'))), m("div", {
        style: "display: flex; justify-content: space-between; align-items: center;"
      }, m("span", {
        style: "color: var(--heading-color); font-weight: 600;"
      }, "\u26F0\uFE0F Pastor Gorbea (Notas)"), m("span", {
        style: "color: ".concat(allowsRatings ? '#4caf50' : '#ffc107', "; font-weight: bold;")
      }, allowsRatings ? '✓ Computa medias' : '⚠️ Excluido medias'))), m("div", {
        style: "margin-top: 12px; font-size: 0.8em; color: var(--muted-color); display: flex; gap: 10px; flex-wrap: wrap;"
      }, m("span", null, m("strong", null, "EU:"), " ", comp.nameEu() || m("em", {
        style: "opacity: 0.5;"
      }, "Sin traducir")), m("span", null, m("strong", null, "EN:"), " ", comp.nameEn() || m("em", {
        style: "opacity: 0.5;"
      }, "Sin traducir")))));
    }))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/CompetitionsPage', CompetitionsPage);